/* globals $ */
(function() {
    'use strict';
    var defaults = {
        sorter: function(items) {
            var codematch = [];
            var wordmatch = [];
            var other = [];
            var escapedQuery = this.query.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var text = this.displayText(item);
                // sort exact airport code matches highest
                if (!text.toLowerCase().indexOf('[' + this.query.toLowerCase() + ']')) {
                    codematch.push(item);
                } else {
                    // sort airports containing words that start with the search value higher
                    if (text.match(new RegExp('\\b' + escapedQuery, 'i'))) {
                        wordmatch.push(item);
                    } else {
                        // leave partial matches at the bottom
                        other.push(item);
                    }
                }
            }
            return codematch.concat(wordmatch, other);
        },

        // extending the default to add case insensitivity
        highlighter: function(item) {
            var text = this.query;
            if (text === '') {
                return item;
            }
            var matches = item.match(/(>)([^<]*)(<)/ig);
            var first = [];
            var second = [];
            var i;
            if (matches && matches.length) {
                //html
                for (i = 0; i < matches.length; ++i) {
                    if (matches[i].length > 2) {//escape '><'
                        first.push(matches[i]);
                    }
                }
            } else {
                //text
                first = [];
                first.push(item);
            }
            text = text.replace((/[()\/.*+?\[\]]/ig), function(mat) {
                return '\\' + mat;
            });
            var reg = new RegExp(text, 'ig');
            for (i = 0; i < first.length; ++i) {
                matches = first[i].match(reg);
                if (matches && matches.length > 0) {//find all text nodes matches
                    second.push(first[i]);
                }
            }
            for (i = 0; i < second.length; ++i) {
                item = item.replace(second[i], second[i].replace(reg, '<strong>$&</strong>'));
            }
            return item;
        },
    };

    // update the associated airport code field
    var onChange = function() {
        var code = $(this).val().toUpperCase();
        var activeTypeahead = $(this).typeahead('getActive');
        if (activeTypeahead && activeTypeahead.name === $(this).val()) {
            $(this).parent().find('.airport-code').val(activeTypeahead.code).change();
        }
    };

    $.fn.airportTypeahead = function(args) {
        args = $.extend({}, defaults, args);

        $(this).typeahead(args).on('keyup change', onChange);

        // check if initial value is an airport code
        $(this).each(function() {
            if ($(this).val().length === 3) {
                for (var key in args.source) {
                    if (args.source.hasOwnProperty(key)) {
                        var airport = args.source[key];
                        if (airport.code === $(this).val()) {
                            $(this).val(airport.name);
                            break;
                        }
                    }
                }
            }

            onChange.call(this);
        });

        return $(this);
    };
})();

